<template>
  <div class="bottom_footer_container" v-if="footerContent.length > 0" v-once>
    <div
      class="footer_game d-flex-column justify-start align-start"
      v-for="content in footerContent"
      :key="content"
      v-memo="[footerContent]"
      :class="[content.is_coming_soon && 'disabled']"
    >
      <img
        :src="`/images/games/${content.slug}/game_icon.webp`"
        loading="lazy"
        :alt="`${content.short_title} Game icon`"
        class="game_icon"
        height="20"
        width="20"
      />
      <p class="t-white font-family-2 bold-l">
        {{ content.short_title }}
      </p>
      <div
        class="d-flex-column justify-start align-start"
        v-if="!content.is_coming_soon"
      >
        <NuxtLinkLocale
          :to="`/${content.slug}/${pack.slug}`"
          class="t-white font-family-2 dark tab_plain regular-m t-grey footer-link"
          exact-active-class="active_tab_orange"
          v-for="pack in [...content?.packs].slice(0, 5)"
          :key="pack"
          v-memo="[content]"
        >
          {{ pack.short_title }}
        </NuxtLinkLocale>
      </div>
      <p v-else class="t-grey-dark font-family-2 regular-m">
        {{ $t("work_with_us.coming_soon") }}
      </p>
      <NuxtLinkLocale
        :to="`/${content.slug}/${content.packs[0].slug}`"
        class="dark tab_plain _white _orange font-family-2 t-white regular-m"
        v-if="content?.packs.length > 5"
      >
        {{ $t("main.view_all") }}
        <ChevDown style="height: 16px; width: 16px" />
      </NuxtLinkLocale>
    </div>
  </div>
</template>

<script setup>
import ChevDown from "~/components/icons/ChevDown.vue";
import { ref } from "vue";
const { locale } = useI18n();
// HOOKS

// REACTIVE
const footerContent = ref([]);

const fetchData = async () => {
  try {
    const { data: response } = await useApiPost("/api/all-game-packs", {
      method: "POST",
      body: {
        locale: locale.value,
      },
      lazy: true,
    });
    if (response) {
      footerContent.value = response;
    }
  } catch (error) {
    console.log(error);
  }
};

await fetchData();

watch(locale, (newVal) => {
  fetchData();
});

// const { data: response } = await useApiFetch("/api/all-game-packs", {
//   method: "POST",
//   body: {
//     locale: getLocale(),
//   },
// });
// if (response.value?.data) {
//   // console.log(response.value?.data)
//   footerContent.value = response.value?.data;
// }
</script>
